export const PERIOD_OPTIONS = [
  { id: '1', name: 'AM' },
  { id: '2', name: 'PM' },
]
